import React, { useState, useEffect } from "react";
import { Row, Container, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import BackArrow from "../../components/backArrow";
import UserShopProfile from "../../components/UserShopProfile/UserShopProfile";
import UserItemShop from "../../components/UserShopItem/UserItemShop";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useGetShopByIdQuery, useGetShopItemsQuery } from "../../features/shop/shopApiSlice";
import { useCreateHelpMutation } from "../../features/user/userApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const Farminguserprofile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { shopid: slugId } = useParams();
  const shopid = extractIdFromSlug(slugId);
  const imageUrl = useSelector((state) => state.imgurl);
  const { name } = useSelector((state) => state.user);

  const [lgShowreport, setLgShowreport] = useState(false);

  const [createShop, setCreateShop] = useState({
    userid: name?._id,
    problem: "",
    desciription: "",
    image: [""],
  });

  /* =======================
     UPDATE IMAGE
  ======================== */
  useEffect(() => {
    setCreateShop((prev) => ({
      ...prev,
      image: imageUrl?.imgurl || "",
    }));
  }, [imageUrl]);

  /* =======================
     RTK Query: Fetch Shop & Items
  ======================== */
  const { data: shopRes, isFetching: isShopLoading } = useGetShopByIdQuery(shopid, { skip: !shopid });
  const { data: itemsRes, isFetching: isItemsLoading } = useGetShopItemsQuery(
    { shopid, page: 1, limit: 15 },
    { skip: !shopid }
  );

  const [createHelp] = useCreateHelpMutation();

  const shopData = shopRes?.data?.Shop || null;
  const itemshow = itemsRes?.regular || [];
  const specialoffer = itemsRes?.specialoffer || [];
  const salespromotion = itemsRes?.salespromotion || [];
  const newItemdata = [...itemshow, ...specialoffer, ...salespromotion];
  const loading = isShopLoading || isItemsLoading;

  /* =======================
     POST SHOP REPORT
  ======================== */
  const PostShopDatas = async (e) => {
    e.preventDefault();

    try {
      const response = await createHelp(createShop).unwrap();
      if (response?.success) {
        setLgShowreport(false);
        SuccessNotify("Form Farming Shop Created Successfully");
        setTimeout(() => {
          navigate(`/Farming-userprofile/${slugId}`);
        }, 1000);
      }
    } catch {
      FailedNotify("Failed To Create Shop");
    }
  };

  return (
    <Container>
      <Row>
        <Col lg="4" md="3" className="screenHeight">
        <Col xs="12" className="d-lg-none mb-2"> <BackArrow mystyle="pt-1 ps-2" /> </Col>
          <div className="border b-radius height_100">
            {shopData ? (
              <UserShopProfile
                PostShopDatas={PostShopDatas}
                setCreateShop={setCreateShop}
                lgShowreport={lgShowreport}
                setLgShowreport={setLgShowreport}
                shopData={shopData}
                id={slugId}
                shopid={shopid}
              />
            ) : (
              <Skeleton height={400} />
            )}
          </div>
        </Col>

        <Col lg="8" md="7" className="screenHeight">
          <div className="border b-radius">
             <div className="ms-3">
              <BackArrow back="/buy-retailer" />
            </div>
            {loading ? (
              <Skeleton count={5} height={120} style={{ marginBottom: "10px" }} />
            ) : (
              <UserItemShop
                back="/Farming-online"
                shopid={shopid}
                regular={itemshow}
                specialoffer={specialoffer}
                salespromotion={salespromotion}
                newItemdata={newItemdata}
                shopData={shopData}
              />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Farminguserprofile;
